<template>
  <VRow>
    <VCol cols="12">
      <VResponsive :aspect-ratio="16/9">
        <ClientOnly>
          <InterviewPlayer
            v-if="vacancy.script.questions.length > 0"
            v-model="question"
            :poster="image"
            :interview="candidate.interview"
            :interviewer="vacancy.script.interviewer"
            :questions="interviewTimestampsFiltered"
            :omit-interviewer-questions="omitInterviewerQuestions"
            :are-questions-equal="areQuestionsEqual"
            @update:omitInterviewerQuestions="updateOmitInterviewerQuestions"
            @play="$emit('play')"
          />
        </ClientOnly>
      </VResponsive>
    </VCol>
  </VRow>
</template>

<script>
import ClientOnly from 'vue-client-only';
import InterviewPlayer from '@huntica/huntica-interview-module/src/components/InterviewPlayer.vue';
import { timestampTypes } from '../../enums';

export default {
  name: 'CandidateInterviewVirtual',
  components: {
    ClientOnly,
    InterviewPlayer,
  },
  props: {
    vacancy: {
      type: Object,
      required: true,
    },
    candidate: {
      type: Object,
      required: true,
    },
    areQuestionsEqual: {
      type: Boolean,
      required: true,
      default: true,
    },
  },
  data() {
    return {
      omitInterviewerQuestions: false,
    };
  },
  computed: {
    question: {
      get() {
        return this.$store.state.candidatePage.activeQuestion;
      },
      set(value) {
        this.$store.commit('candidatePage/setActiveQuestion', value);
      },
    },
    image() {
      return this.candidate.interview.images ? this.candidate.interview.images[0].url : '';
    },
    interviewTimestampsFiltered() {
      if (this.areQuestionsEqual) {
        return this.vacancy.script.questions;
      }

      return this.candidate.interview.timestamps
        .filter(t => t.type === timestampTypes.ANSWERING)
        .map(t => ({
          id: t.questionId,
          questionId: null,
          type: t.questionType,
          file: null,
          question: t.questionText,
          interviewerId: null,
          duration: null,
          startTime: t.startTime,
          speechStopTime: t.stopTime,
          stopTime: null,
          uuid: null,
        }));
    },
  },
  mounted() {
    if (!this.areQuestionsEqual) {
      this.updateOmitInterviewerQuestions(true);
    }
  },
  methods: {
    updateOmitInterviewerQuestions(value) {
      this.omitInterviewerQuestions = value;
    },
  },
};
</script>

<style scoped>
.questions-list {
  overflow-y: auto;
}
</style>

<i18n locale="en" lang="yaml">
  skipQuestionListening: Skip questions
</i18n>

<i18n locale="ru" lang="yaml">
  skipQuestionListening: Пропускать прослушивание вопроса
</i18n>
